<template>
  <div id="revenue-form">
    <div>
      <h1>Overheads</h1>
    </div>
    <div class="form-section">
      <summary-col>
        <h3>Estimated Monthly Overheads</h3>
      </summary-col>
      <data-col>
        <data-row>
          <label>Premises, Rates & Utilities</label>
          <div class="input-wrapper">
          <input class="data-input" v-model="premises"/>
          </div>
        </data-row>
        <data-row>
          <label>Phone/Internet/IT</label>
          <div class="input-wrapper">
          <input class="data-input" v-model="phone"/>
          </div>
        </data-row>
        <data-row>
          <label>Insurance</label>
          <div class="input-wrapper">
          <input class="data-input" v-model="insurance"/>
          </div>
        </data-row>
        <data-row>
          <label>Staff</label>
          <div class="input-wrapper">
          <input class="data-input" v-model="staff"/>
          </div>
        </data-row>
        <data-row>
          <label>Director's Remuneration</label>
          <div class="input-wrapper">
          <input class="data-input" v-model="salary"/>
          </div>
        </data-row>
        <data-row>
          <label>Tax/NI</label>
          <div class="input-wrapper">
          <input class="data-input" v-model="tax"/>
          </div>
        </data-row>
        <data-row>
          <label>Other</label>
          <div class="input-wrapper">
          <input class="data-input" v-model="other"/>
          </div>
        </data-row>
        <data-row>
          <label class="section-summary-label">Total Monthly Overheads</label>
          <div class="data-summary-wrapper">
          <div class="data-summary">£{{ premises + phone + insurance + staff + salary + tax + other }}</div>
          </div>
        </data-row>
      </data-col>
    </div>
    <div id="form-footer">
      <div class="button-wrapper back-button-wrapper">
        <BtnBack title="Back"/>
      </div>
      <div class="button-wrapper next-button-wrapper">
        <BtnNext title="Next" currentPage="overheads" />
      </div>
    </div>
  </div>
</template>

<script>
import BtnNext from './BtnNext.vue'
import BtnBack from './BtnBack.vue'
export default {
  props: {
  },
  computed: {
      premises: {
        get () {
          return this.$store.state.overheads.premises
        },
        set (value) {
          this.$store.commit('setPremises', value)
        }
      },
      phone: {
        get () {
          return this.$store.state.overheads.phone
        },
        set (value) {
          this.$store.commit('setPhone', value)
        }
      },
      insurance: {
        get () {
          return this.$store.state.overheads.insurance
        },
        set (value) {
          this.$store.commit('setInsurance', value)
        }
      },
      staff: {
        get () {
          return this.$store.state.overheads.staff
        },
        set (value) {
          this.$store.commit('setStaff', value)
        }
      },
      salary: {
        get () {
          return this.$store.state.overheads.salary
        },
        set (value) {
          this.$store.commit('setSalary', value)
        }
      },
      tax: {
        get () {
          return this.$store.state.overheads.tax
        },
        set (value) {
          this.$store.commit('setTax', value)
        }
      },
      other: {
        get () {
          return this.$store.state.overheads.other
        },
        set (value) {
          this.$store.commit('setOther', value)
        }
      },
  },
  components: {
    BtnNext,
    BtnBack
  }
}
</script>
